import { Container, Text, Sprite, Graphics } from "pixi.js";
import { ISocialsThemeRendererProps } from "./ISocialsThemeRenderer";

export const renderTheme1 = ({
  container,
  destination,
  integrations,
  widget,
  icons,
  scaleFactor,
}: ISocialsThemeRendererProps) => {
  const options = widget.options;
  const itemsContainer = new Container();

  let currentX = 0;
  const gap = 24 * scaleFactor;

  integrations.forEach((data) => {
    const item = new Container();

    const iconTexture = icons[data.platform];
    const iconSize =
      (options.fontSize === "xs"
        ? 20
        : options.fontSize === "sm"
          ? 24
          : options.fontSize === "md"
            ? 28
            : options.fontSize === "lg"
              ? 32
              : 36) * scaleFactor;

    let iconWidth = 0;

    if (iconTexture) {
      const icon = new Sprite(iconTexture);
      icon.width = iconSize;
      icon.height = iconSize;
      item.addChild(icon);
      iconWidth = iconSize;
    }

    const sizes = {
      ["xs"]: 14,
      ["sm"]: 16,
      ["md"]: 18,
      ["lg"]: 20,
      ["xl"]: 22,
    };

    const fontSize = sizes[(options.fontSize as keyof typeof sizes) || "md"] * scaleFactor;

    // Text
    const textStyle = {
      fontFamily: options.fontFamily || "Roboto",
      fontSize,
      fill: options.textColor,
      fontWeight: options.bold ? "bold" : "normal",
      fontStyle: options.italic ? "italic" : "normal",
      letterSpacing: options.wordSpacing,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any;

    const displayName = data.user?.displayName || `@${data.platform}`;
    const text = new Text({ text: displayName, style: textStyle });

    text.anchor.set(0, 0.5);
    text.x = iconWidth + 16 * scaleFactor;
    text.y = iconSize / 2;

    if (options.underline) {
      const underline = new Graphics();
      underline.moveTo(0, 0);
      underline.lineTo(text.width, 0);
      underline.stroke({ width: 2 * scaleFactor, color: options.textColor });

      underline.x = text.x;
      underline.y = text.y + text.height / 2;

      item.addChild(underline);
    }

    if (options.strike) {
      const strike = new Graphics();
      strike.moveTo(0, 0);
      strike.lineTo(text.width, 0);
      strike.stroke({ width: 2 * scaleFactor, color: options.textColor });

      strike.x = text.x;
      strike.y = text.y; // Center
      item.addChild(strike);
    }

    item.addChild(text);

    item.x = currentX;
    itemsContainer.addChild(item);

    currentX += item.width + gap;
  });

  // Center itemsContainer in destination
  itemsContainer.x = (destination.width - itemsContainer.width) / 2;
  itemsContainer.y = (destination.height - itemsContainer.height) / 2;

  container.addChild(itemsContainer);
};
